import React, { useState } from 'react';
import { FileText, Check } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// Gated download of the full Recovery Revolution research document (gym-owner lead magnet).
export const ResearchDocGate = () => {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle');

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setState('sending');
    try {
      const res = await fetch(`${API}/api/leads/dojo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          magnet_id: 'recovery_research_master',
          source: 'recovery-article-gate',
          metadata: { asset: 'Recovery Revolution research doc' },
        }),
      });
      if (!res.ok) throw new Error('failed');
      setState('done');
    } catch {
      setState('error');
    }
  };

  return (
    <div className="my-12 border border-[#C7FA3E]/40 bg-[#0d1004] p-7 md:p-9" data-testid="research-doc-gate" data-lead-magnet="true">
      <p className="text-[#C7FA3E] text-xs uppercase tracking-[0.25em] mb-3" style={{ fontFamily: 'Oswald, sans-serif' }}>
        <FileText className="w-3.5 h-3.5 inline mr-1.5 -mt-0.5" />
        Free download · For gym &amp; studio owners
      </p>
      <h3 className="text-white text-2xl md:text-3xl mb-3" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>
        Get the full sourced research document
      </h3>
      <p className="text-zinc-400 text-sm leading-relaxed mb-5 max-w-2xl">
        Everything behind this article: per-modality cost tables, ROI models with open assumptions,
        evidence grades for all 11 services, health-department &amp; compliance detail, and 60+ citations —
        with anything unverifiable marked <span className="text-zinc-200">[UNVERIFIED]</span>.
      </p>
      {state === 'done' ? (
        <div data-testid="research-gate-success">
          <p className="inline-flex items-center gap-2 text-[#C7FA3E] text-sm mb-2" style={{ fontFamily: 'Oswald, sans-serif' }}>
            <Check className="w-4 h-4" /> Sent — check your inbox.
          </p>
          <p className="text-zinc-400 text-sm">
            Or open it right now:{' '}
            <a
              href={`${API}/api/recovery/research-doc`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#C7FA3E] underline underline-offset-4"
              data-testid="research-doc-direct-link"
            >
              The Recovery Revolution — full research doc →
            </a>
          </p>
        </div>
      ) : (
        <>
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-lg" data-testid="research-gate-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@yourgym.com"
              autoComplete="email"
              disabled={state === 'sending'}
              className="flex-1 min-w-0 bg-black/50 border border-zinc-700 focus:border-[#C7FA3E] px-4 py-3 text-sm text-white outline-none transition-colors"
              data-testid="research-gate-email"
            />
            <button
              type="submit"
              disabled={state === 'sending'}
              className="px-6 py-3 bg-[#C7FA3E] hover:bg-[#b8e01f] disabled:opacity-60 text-black text-xs font-bold uppercase tracking-widest transition-colors whitespace-nowrap"
              style={{ fontFamily: 'Oswald, sans-serif' }}
              data-testid="research-gate-submit"
            >
              {state === 'sending' ? 'Sending…' : 'Email me the doc'}
            </button>
          </form>
          {state === 'error' && (
            <p className="text-red-400 text-xs mt-2" data-testid="research-gate-error">Something went wrong — try again.</p>
          )}
          <p className="text-zinc-600 text-xs mt-3">No spam. One email with the document, that&apos;s it.</p>
        </>
      )}
    </div>
  );
};
